import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import { AmountFormatCell } from "components/common/formatter";
import { GridLoader } from "components/GridLoader";
import styles from "../Settings.module.scss";

const ExpenseList = ({ loading, expenses, enterEdit }) => {
  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="h-100">
      <div className={`settings-grid h-100 ${styles.expenseSetupGrid}`}>
        <Grid
          data={expenses}
          showLoader={loading}
          loader={
            <div style={{ height: "50px" }}>
              <GridLoader />
            </div>
          }
          style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
        >
          <GridNoRecords>
            {loading ? (
              <span></span>
            ) : (
              expenses && expenses?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <Column
            title=" "
            width="80"
            field="details"
            cell={(props) => <SignatureCell {...props} />}
          />
          <Column field="details" title="Expense Name" width="140px" />
          <Column field="nominalRef" title="Nominal" width="120px" />
          <Column field="netAmount" title="Net" width="140px" cell={AmountFormatCell} headerClassName="grid-header-center" />
          <Column field="vatCodeDisplay" title="VAT Code" width="200px" />
          <Column field="vatAmount" title="VAT" width="120px" cell={AmountFormatCell} headerClassName="grid-header-center" />
          <Column field="active" title="Active" width="80" cell={ActiveCell} />
          <Column title=" " width="50" cell={MyEditCommandCell} />
        </Grid>
      </div>
    </div>
  );
};

export default ExpenseList;
